import { render, staticRenderFns } from "./BraintreeTokenizationKey.vue?vue&type=template&id=2bbbefec&"
import script from "./BraintreeTokenizationKey.vue?vue&type=script&lang=ts&"
export * from "./BraintreeTokenizationKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports